export default __webpack_public_path__ + "static/media/tuna-can-open.927ff962.mp3";